import { api } from './client';

/** One line of the report: label · count · value (₹ number, or text). */
export interface SummaryRow { label: string; count?: string; value?: number | string | null; note?: string; strong?: boolean; gap?: boolean }
export interface SummarySection { key: string; title: string; rows: SummaryRow[] }

export interface MgmtSummary {
  generatedAt: string;
  monthLabel: string;
  /** FY rows run from 1 April to the end of last month, e.g. "Apr – Sep 26". */
  fyLabel: string;
  sections: SummarySection[];
  /** Online orders not yet processed into ERP orders (counted under "pending dispatch"). */
  awaitingOnline: number;
  sales: {
    totalSalesMonth: number;
    ordersPendingDO: number;
    doPendingDispatch: number;
    invoicesPendingAfterDispatch: number;
    returnsMonthCount: number;
    returnsMonthUnits: number;
  };
  purchase: { posRaisedMonth: number; posReceivedMonth: number; purchaseValueMonth: number; pendingPos: number };
  outstanding: { total: number; b45_60: number; b60_90: number; above90: number };
  stock: { totalValue: number; above90Value: number };
  sis: { stores: number; unitsOnHand: number; salesMonthAmount: number };
}

export async function sendManagementSummary(): Promise<{ recipients: number; emailed: number; whatsapped: number; errors: string[] }> {
  const r = await api.post('/management-summary/send');
  return r.data;
}

/** The main Dashboard: the same report, its period rows covering `from`–`to` (inclusive); none = all time. */
export interface TrendPoint { month: string; sales: number; purchase: number; grn: number; sis: number; online: number }
export type DashboardSummary = MgmtSummary & { trend: TrendPoint[] };

export async function getDashboardSummary(period: { from: string; to: string; label: string } | null): Promise<DashboardSummary> {
  const r = await api.get<DashboardSummary>('/management-summary/dashboard', { params: period ?? {} });
  return r.data;
}

/** The morning email as it would go out today — subject, full HTML and recipients. */
export async function getSummaryEmailPreview(): Promise<{ subject: string; html: string; recipients: { fullName: string; email: string | null }[] }> {
  const r = await api.get('/management-summary/email-preview');
  return r.data;
}
